// ─── Catalogue d'ingrédients (base + corrections perso) ───────────
// Encapsule les DEUX écoutes (base partagée + corrections personnelles) et le
// calcul des listes effectives, pour que les écrans qui n'ont besoin que de
// l'emoji d'un ingrédient n'aient pas à tout recâbler.
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '@mop/core';
import { ecouterBase } from '../services/ingredientsBase';
import { ecouterPerso, ingredientsEffectifs, rayonsEffectifs } from '../services/ingredientsPerso';
import { rayonDe, RAYONS } from '../services/catalogueIngredients';

export default function useCatalogueIngredients() {
  const { user } = useAuth();
  const [base, setBase] = useState([]);
  const [baseRayons, setBaseRayons] = useState([]);
  const [perso, setPerso] = useState({ ajouts: [], masques: [], modifs: {}, rayonsAjouts: [], rayonsMasques: [], rayonsModifs: {} });

  useEffect(() => ecouterBase((items, rayons) => { setBase(items); setBaseRayons(rayons); }, () => {}), []);
  useEffect(() => ecouterPerso(user?.uid, setPerso, () => {}), [user?.uid]);

  const items = useMemo(() => ingredientsEffectifs(base, perso), [base, perso]);
  const rayons = useMemo(() => rayonsEffectifs(baseRayons, perso, RAYONS), [baseRayons, perso]);

  // Emoji d'un ingrédient = celui de son RAYON. Comparaison sur le nom
  // normalisé : les ingrédients d'une recette sont saisis librement, ils ne
  // pointent pas le catalogue par identifiant.
  const emojiPour = useMemo(() => {
    const parNom = new Map();
    for (const i of items) {
      const cle = String(i.nom || '').trim().toLowerCase();
      if (cle && !parNom.has(cle)) parNom.set(cle, i.categorie);
    }
    return (nom) => {
      const cat = parNom.get(String(nom || '').trim().toLowerCase());
      return cat ? (rayonDe(cat, rayons).emoji || '🛒') : '🛒';
    };
  }, [items, rayons]);

  // Unité connue pour un ingrédient (sert à pré-remplir une saisie manuelle).
  const uniteDe = useMemo(() => {
    const parNom = new Map();
    for (const i of items) {
      const cle = String(i.nom || '').trim().toLowerCase();
      if (cle && !parNom.has(cle)) parNom.set(cle, i.unite || '');
    }
    return (nom) => parNom.get(String(nom || '').trim().toLowerCase()) || '';
  }, [items]);

  return { items, rayons, emojiPour, uniteDe };
}
